export const CAMPAIGN_STATUS = {
  ALL: "",
  SCHEDULE: "scheduled",
  IN_PROGRESS: "in_progress",
  STOPPED: "stopped",
  COMPLETED: "completed",
  TEST: "testing",
} as const;